module.exports = __webpack_public_path__ + "img/logo.9a3946bf.png";